import React from 'react';
import { Card, CardContent } from '../ui/card';
import { NavigationArrow, Clock, CheckCircle, Warning } from '@phosphor-icons/react';

/**
 * Clickable stats cards — clicking a card sets the filter status.
 * Pass filterStatus so the active card shows a ring.
 */
export const StatsCards = ({ visits, filterStatus, onFilterChange }) => {
  const countBy = (status) => visits.filter((v) => v.validation_status === status).length;

  const cards = [
    {
      key: 'all',
      testId: 'evv-stat-total',
      value: visits.length,
      label: 'Total Visits',
      icon: NavigationArrow,
      iconBg: 'bg-indigo-50',
      iconColor: 'text-indigo-600',
      hoverBorder: 'hover:border-indigo-300',
      activeRing: 'ring-indigo-200',
      onClick: () => onFilterChange(''),
      isActive: filterStatus === '',
    },
    {
      key: 'pending',
      testId: 'evv-stat-pending',
      value: countBy('Pending'),
      label: 'Pending',
      icon: Clock,
      iconBg: 'bg-amber-50',
      iconColor: 'text-amber-600',
      hoverBorder: 'hover:border-amber-300',
      activeRing: 'ring-amber-200',
      onClick: () => onFilterChange('Pending'),
      isActive: filterStatus === 'Pending',
    },
    {
      key: 'validated',
      testId: 'evv-stat-validated',
      value: countBy('Validated'),
      label: 'Validated',
      icon: CheckCircle,
      iconBg: 'bg-emerald-50',
      iconColor: 'text-emerald-600',
      hoverBorder: 'hover:border-emerald-300',
      activeRing: 'ring-emerald-200',
      onClick: () => onFilterChange('Validated'),
      isActive: filterStatus === 'Validated',
    },
    {
      key: 'exception',
      testId: 'evv-stat-exceptions',
      value: countBy('Exception'),
      label: 'Exceptions',
      icon: Warning,
      iconBg: 'bg-red-50',
      iconColor: 'text-red-600',
      hoverBorder: 'hover:border-red-300',
      activeRing: 'ring-red-200',
      onClick: () => onFilterChange('Exception'),
      isActive: filterStatus === 'Exception',
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      {cards.map((card) => {
        const Icon = card.icon;
        return (
          <Card
            key={card.key}
            className={`border-slate-200 cursor-pointer transition-colors ${card.hoverBorder} ${
              card.isActive ? `ring-2 ${card.activeRing}` : ''
            }`}
            onClick={card.onClick}
            data-testid={card.testId}
          >
            <CardContent className="pt-4">
              <div className="flex items-center gap-3">
                <div className={`p-2 ${card.iconBg} rounded-lg`}>
                  <Icon size={24} className={card.iconColor} />
                </div>
                <div>
                  <p className="text-sm text-slate-500">{card.label}</p>
                  <p className="text-2xl font-bold text-slate-900">{card.value}</p>
                </div>
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};
